const TmpPE005 = (page) => {
  const modifiedPage = {
    ...page
  };

  // Inject page.id into each focus point if present
  if (Array.isArray(page.focusPointsData)) {
    page.focusPointsData.forEach((fp) => {
      fp.page = page.id;
    });
  }

  // Extract metadata separately
  const metadata = {
    media: page.mediaData || [],
    images: page.imageData || [],
    materials: page.materialsData || [],
    eMentor: page.eMentorData || [],
    focusPoints: page.focusPointsData || []
  };

  return { modifiedPage, metadata };
};

export default TmpPE005;
